module.exports = "/_next/static/images/8a00257d0fd3e26b0bd814f0a4563ae3-rewards-home-card@3x.png";